<template>


    <div class="page-content">   
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>Ingreso datos OT {{ idcotizacionvehiculo }}</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	     
		<div class="content-boxed">

  			<div class="content bottom-0">

				
				<div v-if="OT.TipoCliente == 3" data-height="110" class="caption caption-margins round-medium shadow-large">
					<div class="caption-bottom left-20 bottom-15">
						<h1 class="color-white bottom-0 bolder">{{ OT.nombre }}</h1>
					</div>
					<div class="caption-overlay bg-black opacity-75"></div>
					<div class="caption-bg bg-27"></div>
				</div>
				<div v-else data-height="110" class="caption caption-margins round-medium shadow-large">
					<div class="caption-bottom left-20 bottom-15">
						<h1 class="color-white bottom-0 bolder">{{ OT.nombre }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.paterno }}</h1>
						<h1 class="color-white bottom-0 bolder">{{ OT.materno }}</h1>
					</div>
					<div class="caption-overlay bg-black opacity-75"></div>
					<div class="caption-bg bg-27"></div>
				</div>  
				
				<iframe class="caption caption-margins round-medium shadow-large" width="98%" height="600px" :src="getIframeSrc()" frameborder="0"></iframe>

				<table width='100%' class="bg-gray1-dark">

					<tr>
						<td width='70%' class="row bg-gray1-dark"></td>
						<td  class="row bg-gray1-dark">
								<div style="text-align: right">
								<VueSignaturePad
									id="signature"
									width="400px"
									height="200px"
									ref="signaturePad"
								/>
								</div>

						</td>
						<td width='5%' class="row bg-gray1-dark">								
							
								<div class="col-3 mt-2">
									<button  @click="undoimage" class="button button-s shadow-small button-circle bg-dark1-dark">
										<i class="fa fa-times"></i>
										Limpiar firma
									</button>
								</div>
						</td>
					</tr>

				</table>

                <div class="contact-form">
                    <form onsubmit="event.preventDefault();" class="contactForm" id="Formsubmit">
						<div class="content-boxed">
								<a href="#" class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton" @click="siguiente" data-formId="dataForm">Siguiente</a>
						</div>

                    </form>			
                </div>
            </div>

 


    	</div>
		
    </div>


</template>

<style scoped>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image:url(./../../assets/images/firmacliente.png),
  linear-gradient(white, white),
  radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-size:400px;
  background-origin: border-box;
  background-clip: content-box, border-box;
}

</style>


<script>

import * as db from "./../../database.js";
import * as validate from "./../../validate.js";

import VueSignaturePad from 'vue-signature-pad';

export default {
	data() {
      return {
		  params:'{"valkey":"'+localStorage.getItem('idcotizacionvehiculo')+'","tablename":"T_VEH_COTIZACIONVEHICULO"}',
		  idcotizacionvehiculo:0,
		  fecha:"",
		  sucursal:"" ,
		  idexterno: null,
		  idagenda:0,
		  Direccioncliente:{},
		  OT:{}
		}
	},

	created(){
		this.idcotizacionvehiculo=localStorage.getItem('idcotizacionvehiculo');
		this.idagenda=localStorage.getItem('idagenda');
		this.userimageurl="background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")"  
		this.sucursal=JSON.parse(localStorage.getItem('user')).sucursal  
		this.fecha=localStorage.getItem('fechaagenda')  


	},

	mounted() {      

		let strSql;

		strSql="SELECT IN_KILOMETRAJEVEHICULO_COTIZACIONVEHICULO kilometraje,"
			+"DT_FECHAENTREGAOT_COTIZACIONVEHICULO fechaentregaot,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,120) fechaentrega,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,108) horaentrega,"
			+"COT.IN_ESORDENTRABAJOINTERNA_COTIZACIONVEHICULO datatipoot,"
			+"COT.IN_COD_TIPOTRABAJO datatipotrabajo,"
			+"CLI.ST_NOMBRE_CLIENTE nombre,"
			+"CLI.ST_APEPAT_CLIENTE paterno,"
			+"CLI.ST_APEMAT_CLIENTE materno,"
			+"CLI.ST_FONO1_CLIENTE fono1,"
			+"CLI.ST_FONO2_CLIENTE fono2,"
			+"CLI.ST_EMAIL_CLIENTE email,"
			+"'"+ db.getServerHTTP()+"/taller/tlrShowOT2.aspx?id='+ST_IDEXTERNO_COTIZACIONVEHICULO+'&file='idexternopdf,"
			+"ST_IDEXTERNO_COTIZACIONVEHICULO idexterno," 
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL1_VEHICULO) marca,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL2_VEHICULO) modelo,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL3_VEHICULO) version,"
			+"IN_AGNOFABRICACION_VEHICULO agno,ST_PLACAPATENTE_VEHICULO placapatente,ST_NVIN_VEHICULO vin,"
			+"CLI.IN_TIPO_CLIENTE TipoCliente"
			+" FROM T_VEH_COTIZACIONVEHICULO COT,T_VEH_VEHICULO V,T_CLI_CLIENTE CLI"
			+" WHERE COT.IN_COD_COTIZACIONVEHICULO="+this.idcotizacionvehiculo
			+" AND COT.IN_COD_VEHICULO=V.IN_COD_VEHICULO"
			+" AND COT.IN_COD_CLIENTE=CLI.IN_COD_CLIENTE"

		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.OT=result.data.data
			this.idexterno = this.OT.idexterno
		}}); 
/*
		strSql="SELECT TOP 1 ST_DESC_DIRECCION direccion,ST_CASADPTO_DIRECCION casa,IN_NUMERO_DIRECCION numero,"
			+ "C1.ST_DESC_DETALLECLASIFICACION ciudad," 
			+ "C2.ST_DESC_DETALLECLASIFICACION comuna" 
			+" FROM T_VEH_COTIZACIONVEHICULO COT,T_CLI_CLIENTE CLI,T_GEN_DIRECCION D,T_GEN_DETALLECLASIFICACION C1,T_GEN_DETALLECLASIFICACION C2"
			+" WHERE COT.IN_COD_COTIZACIONVEHICULO="+this.idcotizacionvehiculo
			+" AND COT.IN_COD_CLIENTE=CLI.IN_COD_CLIENTE"
			+" AND D.IN_CODENTIDAD_DIRECCION=CLI.IN_COD_CLIENTE"
			+" AND (IN_ENTIDAD_DIRECCION=2 OR IN_ENTIDAD_DIRECCION=3)" 
			+" AND D.IN_VALORNIVEL1REGIONCOMUNA_DIRECCION=C1.IN_COD_DETALLECLASIFICACION"
			+" AND D.IN_VALORNIVEL2REGIONCOMUNA_DIRECCION=C2.IN_COD_DETALLECLASIFICACION"

		db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			this.Direccioncliente=result.data.data
		}}); 
*/
},


	methods: {
		undoimage() {
		this.$refs.signaturePad.clearSignature();

			//window.location="/Wizardot4draw"
			
				//this.$refs.signaturePad.fromDataURL('./../../assets/images/imagenfondoservicio.png')
		},

		undo() {
			alert('undo');
		this.$refs.signaturePad.undoSignature();
		},

		getIframeSrc() {
			// return db.getServerHTTP() + '/taller/tlrShowOT2.aspx?id=' + this.idexterno;

			let url = db.getServerHTTP() + '/taller/tlrShowOT.aspx?id=' + this.idexterno;

			// Comprobar y reemplazar la URL si es necesario
			if (url.startsWith("https://puente.valenzueladelarze.cl/")) {
				url = url.replace("https://puente.valenzueladelarze.cl/", "https://vyd.netcar.cl/");
			}

			if (url.startsWith("http://qa.netcarportillosur.com/")){
				url = db.getServerHTTP() + 'resources/_QaPortilloSur/taller/tlrShowOT.aspx?id=' + this.idexterno;
			}

			if (url.startsWith("https://preproduccionxxi.netcar.cl/")){
				url = db.getServerHTTP() + 'resources/_netcarsiglo21com/taller/tlrShowOT.aspx?id=' + this.idexterno;
			}

			if (url.startsWith("https://puente.xxi.cl/")) {
				url = 'https://preproduccionxxi.netcar.cl/resources/_netcarsiglo21com/taller/tlrShowOT.aspx?id=' + this.idexterno;
			}

			return url;

		},

		siguiente()
		{


			const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
			console.log(data)
			if(data!=null)
			{
			db.getFx2("ot.saveimagesign",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","data":"'+ data+'"}').then(result => {
				
				const respuesta = Array.isArray(result) ? result[0] : result;

				console.log(respuesta.data);

				if (respuesta.data.err != "")
				{
					alert(respuesta.data.err);
					console.log(respuesta.data.err);
				}
				else
				{
					window.location="/Wizardot7printemail";
				}
			});
			}
		}


	}
}

</script>
